import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Colors from '../../../../../constants/Colors';
import { MetricProps } from '../../../../../graphs/AirQualityGraph';

interface AirQualitySafeLevelsSectionProps {
  selectedMetric: MetricProps,
}

const AirQualitySafeLevelsSection = ({ selectedMetric }: AirQualitySafeLevelsSectionProps) => (
  selectedMetric?.thresholds?.length > 0 ? <View style={styles.container}>
    <View style={[styles.section, !(selectedMetric.thresholds[2]) && styles.sectionTrailing]}>
      {selectedMetric.thresholds[0] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[styles.icon, { backgroundColor: selectedMetric.thresholds[0].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[0].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[0].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
      {selectedMetric.thresholds[1] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[
            styles.icon, { backgroundColor: selectedMetric.thresholds[1].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[1].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[1].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
    </View>
    <View style={[styles.section, !(selectedMetric.thresholds[4]) && styles.sectionTrailing]}>
      {selectedMetric.thresholds[2] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[styles.icon, { backgroundColor: selectedMetric.thresholds[2].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[2].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[2].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
      {selectedMetric.thresholds[3] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[styles.icon, { backgroundColor: selectedMetric.thresholds[3].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[3].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[3].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
    </View>
    <View style={[styles.section, styles.sectionTrailing]}>
      {selectedMetric.thresholds[4] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[styles.icon, { backgroundColor: selectedMetric.thresholds[4].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[4].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[4].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
      {selectedMetric.thresholds[5] && <View style={styles.sectionContainer}>
        <View style={styles.sectionSubContainer}>
          <View style={[styles.icon, { backgroundColor: selectedMetric.thresholds[5].color }]} />
          <Text style={styles.text}>{selectedMetric.thresholds[5].title}</Text>
        </View>
        <Text style={styles.text}>
          {`${selectedMetric.thresholds[5].value} ${selectedMetric.unit}`}
        </Text>
      </View>}
    </View>
  </View> : null);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingVertical: 8,
    borderTopWidth: 1.5,
    borderTopColor: Colors.light.hereworksWhite500,
  },
  sectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 4,
  },
  sectionSubContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  section: {
    paddingEnd: 16,
    marginEnd: 16,
    flex: 1,
    justifyContent: 'space-between',
    borderEndWidth: 1,
    borderEndColor: Colors.light.hereworksWhite500,
  },
  sectionTrailing: {
    paddingEnd: 0,
    marginEnd: 0,
    borderEndWidth: 0,
  },
  icon: {
    width: 8,
    height: 8,
    borderRadius: 8,
    marginEnd: 8,
    backgroundColor: '#000',
  },
  text: {
    fontSize: 14,
    lineHeight: 20,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_400Regular',
    textAlign: 'right',
  },
});

export default AirQualitySafeLevelsSection;
